<template>
  <div class="wrapper">
    <dashboard-bar refreshButton />
    <div class="wrapp">
      <div class="row">
        <div class="col-12">
          <span class="header-icon">
            <font-awesome-icon :icon="['fas', 'address-book']" />
          </span>
          <h2>{{ $t('blacklist.pageTitle') }}</h2>
        </div>
      </div>

      <div class="col-12">
        <div class="row">
          <div class="col-4 mt-3 pl-0 pr-0">
            <form class="form-inline">
              <div class="form-group">
                <input
                  style="width: 100%;"
                  type="text"
                  class="form-control"
                  :placeholder="$t('blacklist.searchInput')"
                  @keyup="searchTerm"
                  v-model="search"
                />
              </div>
              <button
                @click="
                  search = null;
                  setData();
                "
                type="button"
                class="btn btn-outline-primary"
              >
                {{ $t('blacklist.searchButton') }}
              </button>
            </form>
          </div>
          <div class="col-4 text-center mt-3 pl-0 pr-0">
            <span class="labelBlacklist">
              {{ $t('blacklist.totalBlacklist') }}: {{ totalDocuments }}
            </span>
          </div>
          <div class="col-4 text-right mt-3 pl-0 pr-0">
            <b-button variant="primary" v-b-modal.modal-add-blacklist
              > {{ $t('blacklist.addClient') }}</b-button
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-table
            striped
            id="manual-table"
            class="mt-4"
            :items="items"
            :fields="fields"
            :busy="loading"
            @sort-changed="sortingChanged"
            no-local-sorting
          >
            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner type="grow" class="align-middle"></b-spinner>
              </div>
            </template>
            <!-- Email -->
            <template v-slot:cell(email)="row">
              {{ row.item.email }}
            </template>
            <!-- Telefone -->
            <template v-slot:cell(phone)="row">
              {{ row.item.inviteId && row.item.inviteId.phone ? row.item.inviteId.phone : (row.item.phone ? row.item.phone : "-") }}
            </template>
            <!-- Control ID -->
            <template v-slot:cell(controlId)="row">
              {{ row.item.inviteId.controlId }}
            </template>
            <!-- Ação -->
            <template v-slot:cell(actionId)="row">
              {{ row.item.actionName }}
            </template>
            <!-- ClientId -->
            <template v-slot:cell(clientId)="row">
              {{ row.item.clientId }}
            </template>
            <!-- Canal -->
            <template v-slot:cell(channel)="row">
              {{ row.item.channel }}
            </template>
            <!-- Data Blacklist -->
            <template v-slot:cell(createdAt)="row">
              {{ dateFormat(new Date(row.item.createdAt)) }}
            </template>
            <template v-slot:cell(actions)="row">
              <div class="buttons-area" style="min-width: 90px;">
                <button
                  class="btn btn-outline-danger"
                  @click="
                    removeBlackList(row.item.email, row.item.inviteId._id, row.item)
                  "
                >
                  <font-awesome-icon :icon="['fas', 'trash-alt']" />
                </button>
              </div>
            </template>
          </b-table>
          <div v-show="!loading" class="footer">
            <div class="pagination-area-blacklist mt-1">
              <paginate
                :pageCount="documents"
                :clickHandler="setData"
                :prevText="'‹'"
                :nextText="'›'"
                :activeClass="'active'"
                :containerClass="'pagination b-pagination'"
                :pageClass="'page-item'"
              ></paginate>
            </div>
            <div class="row mr-2">
              <div class="mr-3">
                <div
                  v-if="loadingDownloadIconCsv"
                  class="text-center text-primary my-2"
                >
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                </div>
                <a v-else :title="$t('blacklist.exportCsv')">
                  <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none dropdown-csv"
                    no-caret
                  >
                    <template #button-content>
                      <span class="xls">
                        <i class="fas fa-file-csv"></i>
                      </span>
                    </template>
                    <b-dropdown-item @click="exportData('csv', 'comma')">{{
                      $t('blacklist.csvCommaSeparator')
                    }}</b-dropdown-item>
                    <b-dropdown-item @click="exportData('csv', 'pipe')">{{
                      $t('blacklist.csvPipeSeparator')
                    }}</b-dropdown-item>
                  </b-dropdown>
                </a>
              </div>
              <div>
                <div
                  v-if="loadingDownloadIconXls"
                  class="text-center text-primary my-2"
                >
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                </div>
                <a
                  v-else
                  @click="exportData('xlsx', null)"
                  :title="$t('blacklist.exportXls')"
                >
                  <span class="xls">
                    <i class="fas fa-file-excel"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      ok-title="Adicionar"
      @ok="addInBlacklist"
      cancel-title="Cancelar"
      id="modal-add-blacklist"
      title="Adicionar cliente"
      size="lg"
    >
      <div style="display: flex; margin-bottom: 15px;">
        <label style="width: 160px; margin-top: 5px; font-weight: 600;"
          >E-mail do cliente:</label
        >
        <input
          v-model="email"
          placeholder="Digite o e-mail do cliente"
          class="form-control"
        />
      </div>

      <div style="display: flex;margin-bottom: 15px;">
        <label style="width: 160px; margin-top: 5px; font-weight: 600;"
          >ClientId:</label
        >
        <input
          v-model="clientId"
          placeholder="Digite o clientId do cliente"
          class="form-control"
        />
      </div>

      <div style="display: flex;margin-bottom: 15px;">
        <label style="width: 160px; margin-top: 5px; font-weight: 600;"
          >Telefone:</label
        >
        <input
          v-model="phone"
          placeholder="Digite o telefone do cliente"
          class="form-control"
        />
      </div>

      <br />
      <label style="font-weight: 600;">Motivo</label>
      <b-form-textarea
        id="textarea"
        v-model="reason"
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import dashboardBar from '@/components/molecules/dashboard-bar';
import api from '@/services/api';

export default {
  name: 'Blacklist',

  components: {
    Paginate,
    dashboardBar,
  },

  data: () => ({
    sortBy: null,
    sortDesc: null,
    downloadType: null,
    userAuth: null,
    typingTimer: null,
    doneTypingInterval: 600,
    search: null,
    loading: true,
    page: 1,
    loadingDownloadIconXls: false,
    loadingDownloadIconCsv: false,
    dates: {
      start: null,
      end: null,
    },
    fields: [],
    items: [],
    documents: 0,
    totalDocuments: 0,
    actions: [],
    actionName: null,
    email: null,
    reason: null,
    phone: null,
    clientId: null,
  }),

  watch: {
    actionGroupData: function watchactionGroup() {
      this.setData();
    },
    myActionId: function watchMyActionId() {
      this.setData();
    },
    myActionsIds: function watchMyActionsIds() {
      this.setData();
    },
    calendarDates: function watchCalendarDates() {
      this.setData();
    },
  },

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('authentication', ['userProfile']),
  },

  methods: {
    ...mapActions('calendar', ['setDates']),

    async addInBlacklist() {
      try {
        await api.post(
          '/blacklist/send-client',
          {
            email: this.email,
            reason: this.reason,
            companyId: this.userAuth.companyId,
            phone: this.phone,
            clientId: this.clientId
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        swal({ text: 'Cliente adicionado!', icon: 'success' });

        this.email = '';
        this.reason = '';
        this.phone = '';
        this.clientId = '';
        await this.setData();
      } catch (error) {
        window.console.log(error);
      }
    },

    async deleteBlacklist(email, inviteId, item) {
      if (item.phone && item.phone !== undefined && item.phone !== '-') {
        try {
          await api.delete(`/blacklist/delete/phone/${item.phone}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          });
          swal({
            title: this.$t('blacklist.messages.removeOk.title'),
            text: this.$t('blacklist.messages.removeOk.description'),
            icon: 'success',
          });
        } catch (error) {
          swal({
            title: this.$t('blacklist.messages.error.title'),
            text: this.$t('blacklist.messages.error.description'),
            icon: 'error',
          });
        }
      } else if (item.clientId && item.clientId !== undefined && item.clientId !== '-') {
        try {
          await api.delete(`/blacklist/delete/clientId/${item.clientId}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          });
          swal({
            title: this.$t('blacklist.messages.removeOk.title'),
            text: this.$t('blacklist.messages.removeOk.description'),
            icon: 'success',
          });
        } catch (error) {
          swal({
            title: this.$t('blacklist.messages.error.title'),
            text: this.$t('blacklist.messages.error.description'),
            icon: 'error',
          });
        }
      } else if(email && email !== undefined) {
        try {
          await api.delete(`/blacklist/delete/${email}/${inviteId}`, {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          });
          swal({
            title: this.$t('blacklist.messages.removeOk.title'),
            text: this.$t('blacklist.messages.removeOk.description'),
            icon: 'success',
          });
        } catch (error) {
          swal({
            title: this.$t('blacklist.messages.error.title'),
            text: this.$t('blacklist.messages.error.description'),
            icon: 'error',
          });
        }
      }
      this.setData();
    },

    removeBlackList(email, inviteId, item) {
      swal({
        title: this.$t('blacklist.messages.removeBlackList.title'),
        text: this.$t('blacklist.messages.removeBlackList.description'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((deleted) => {
        if (deleted) {
          this.deleteBlacklist(email, inviteId, item);
        }
      });
    },

    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.setData();
    },

    async searchTerm() {
      if (this.search !== '' && this.search !== null) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.setData, this.doneTypingInterval);
      }

      if (this.search === '') {
        this.search = null;
        this.setData();
      }
    },

    async setData(page) {
      this.loading = true;

      const response = await api.get('/blacklist', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          companyId: this.userAuth.companyId,
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          groupId: this.actionGroupData._id,
          search: this.search,
          page: page || this.page,
          limit: 10,
          sortDesc: this.sortDesc,
          sortBy: this.sortBy,
          userId: this.userAuth._id,
        },
      });

      this.loading = false;
      this.items = response.data.items;
      this.documents = response.data.documents;
      this.totalDocuments = response.data.totalDocuments;
    },

    async exportData(type, csvSeparator) {
      // checks if the total docs to download is greater then 500k
      if (this.documents * 10 > 500000) {
        swal({
          title: this.$t('scheduling.messages.maxDownloadError.title'),
          text: this.$t('scheduling.messages.maxDownloadError.description'),
          icon: 'warning',
        });
        return;
      }

      if (type === 'xlsx') {
        this.loadingDownloadIconXls = true;
      } else {
        this.loadingDownloadIconCsv = true;
      }

      if (csvSeparator === 'comma') {
        csvSeparator = ',';
      }
      if (csvSeparator === 'pipe') {
        csvSeparator = '|';
      }

      this.apiServerlessDownloads = process.env.API_SERVERLESS_DOWNLOADS;

      try {
        await api.get(
          `${this.apiServerlessDownloads}/blacklist/download/${this.userAuth.companyId}/${type}`,
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
            params: {
              startDate: this.calendarDates.start,
              endDate: this.calendarDates.end,
              actionId: this.myActionsIds.length === 0 ? null : JSON.stringify(this.myActionsIds),
              groupId: this.actionGroupData._id,
              search: this.search,
              csvSeparator,
            },
          },
        );

        swal({
          title: this.$t('blacklist.messages.export.title'),
          text: this.$t('blacklist.messages.export.description'),
          icon: 'success',
        });
      } catch (error) {
        swal({
          title: this.$t('blacklist.messages.error.title'),
          text: error.response.data.message,
          icon: 'error',
        });
      }

      if (type === 'xlsx') {
        this.loadingDownloadIconXls = false;
      } else {
        this.loadingDownloadIconCsv = false;
      }
    },

    dateFormat(param) {
      const date = format(param, 'dd/MM/yyyy', { locale: pt });
      return date;
    },

    makeToast(message, title, append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(`${message}`, {
        title,
        autoHideDelay: 5000,
        appendToast: append,
      });
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.fields = [
      {
        key: 'email',
        label: this.$t('blacklist.labelsTable.email'),
      },
      {
        key: 'controlId',
        label: this.$t('blacklist.labelsTable.controlId'),
      },
      {
        key: 'actionId',
        label: this.$t('blacklist.labelsTable.action'),
      },
      {
        key: 'clientId',
        label: "ClientID",
      },
      {
        key: 'phone',
        label: "Telefone",
      },
      {
        key: 'channel',
        label: this.$t('blacklist.labelsTable.channel'),
      },
      {
        key: 'reason',
        label: this.$t('blacklist.labelsTable.reason'),
      },
      {
        key: 'createdAt',
        label: this.$t('blacklist.labelsTable.blackListDate'),
      },
      {
        key: 'actions',
        label: this.$t('blacklist.labelsTable.actions'),
      },
    ];
  },

  mounted() {
    this.setData();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';

.wrapper {
  padding: 8px;
}

.wrapp {
  background-color: $white;
  border-radius: 4px;
  border: 1px solid $gray-light;
  @each $i in $directions {
    @extend %default-padding-#{$i};
  }
  @extend %half-padding-bottom;

  h2 {
    text-transform: uppercase;
    font-size: 21px;
    font-weight: 100;
    color: $gray;
  }

  .header-icon {
    float: left;
    font-size: 12px;
    margin-top: 4px;
    padding-right: 12px;
    color: $gray;
  }

  .refresh-icon {
    margin-top: 1px;
    color: $primary;
    cursor: pointer;
    &:hover {
      color: green;
    }
  }
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

.pagination-area-blacklist >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-blacklist .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-blacklist a {
  outline: none;
}
.labelBlacklist {
  font-size: 20px;
  color: #bdbdbd;
}
.dropdown-csv {
  border: 0px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/blacklist/index.vue